(function () {
  if (customElements.get('giris-duvari')) return;

  class GirisDuvari extends HTMLElement {
    connectedCallback() {
      this.esik = parseFloat(this.getAttribute('data-esik'));
      if (isNaN(this.esik)) this.esik = 50;
      this.acik = false;

      this.onScroll = this.onScroll.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      this.onFocus = this.onFocus.bind(this);

      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll, { passive: true });
      this.onScroll();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
      document.removeEventListener('keydown', this.onKeydown, true);
      document.removeEventListener('focusin', this.onFocus, true);
    }

    get yuzde() {
      const belge = document.documentElement;
      const kaydirilabilir = belge.scrollHeight - window.innerHeight;
      if (kaydirilabilir <= 0) return 0;
      return (window.scrollY / kaydirilabilir) * 100;
    }

    onScroll() {
      if (this.acik) return;
      if (this.yuzde >= this.esik) this.ac();
    }

    ac() {
      if (this.acik) return;
      this.acik = true;

      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);

      this.hidden = false;
      document.documentElement.classList.add('giris-duvari-acik');

      // Kapatma yolu bırakılmaz: ESC engellenir, odak kutunun dışına çıkamaz.
      document.addEventListener('keydown', this.onKeydown, true);
      document.addEventListener('focusin', this.onFocus, true);

      const kutu = this.querySelector('.giris-duvari__kutu');
      if (kutu) kutu.focus({ preventScroll: true });
    }

    onKeydown(event) {
      if (event.key === 'Escape' || event.key === 'Esc') {
        event.preventDefault();
        event.stopPropagation();
      }
    }

    onFocus(event) {
      if (this.contains(event.target)) return;
      const odaklanabilir = this.querySelector('a[href], button');
      if (odaklanabilir) odaklanabilir.focus({ preventScroll: true });
    }
  }

  customElements.define('giris-duvari', GirisDuvari);
})();
